import React from 'react'

export function StockOutListSettingsFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .header-caption {
          background-color: darkgrey;
          color: whitesmoke;
          padding: 3px 10px;
          margin: 5px 0;
        }
        .form-container {
          font-size: 0.75em;
          padding: 0 10px;
        }

        #main-container {
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        #main-container #rpp{
          flex: 1;
        }
        .content-wrapper { overflow: auto; }
      `}
      </style>
    </React.Fragment>
  )
}

export function DataFillFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .checkbox-fetch-all-container {
          display: flex;
          height: 25px;
          margin-bottom: 7px;
        }
        .checkbox-fetch-all-container input {
          margin: auto 0;
          margin-right: 5px;
        }
        .fetch-all-btn {
          border: solid 0.5px transparent;
          background-color: transparent;
          font-size: 0.8em;
        }
        #date-created-fetch-all-container *,
        #date-released-fetch-all-container * {
          cursor: pointer;
        }
        #date-created-fetch-all-btn:hover,
        #date-released-fetch-all-btn:hover {
          border: solid 0.5px lightgrey;
        }

        #date-filter-form-container {
          padding-left: 10px;
        }
        .date-field-form-container {
        }
        .date-from, .date-to {
          display: flex;
        }
        .date-from label , .date-to label{
          flex: 0.7;
        }
        .date-from input, .date-to input {
          flex: 3;
          font-size: 0.75em;
          font-family: arial;
          padding: 3px;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function RecordsPerPageFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        #rpp {
          margin-top: 20px;
        }
        #rpp-form {
          display: flex;
          padding-left: 10px;
        }
        #rpp-form input {
          flex: 2;
          font-size: 0.9em;
          font-family: arial;
          padding: 3px;
        }
        #rpp-form label {
          flex: 1;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function ActionButtonsStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        #action-button-container {
          display: flex;
          justify-content: flex-end;
          padding: 10px 0;
        }
      `}
      </style>
  </React.Fragment>
  )
}
